// Q&A：キーワード検索
$(function () {
  // 検索時、未入力ならlocation.hrefで遷移
  $(".js--form-submit").on("click", (e) => {
    var questionKeyword = $(".js-question_keyword");

    if (questionKeyword.val() !== "") {
      $(".js-question_search-form").submit();
    } else {
      location.href = "/questions/result";
    }
  });
});

// 検索後の画面表示でキーワード入力欄の値を初期化
document.addEventListener("DOMContentLoaded", function () {
  const keywordInput = document.querySelector(".js-question_keyword");
  if (keywordInput) {
    keywordInput.value = "";
  }
});
